import { IconButton, Paper } from '@mui/material';
import Menu from '@mui/material/Menu';
import React from 'react';
import { useMenu } from '../../../../hooks/use-menu';
import {
  DEFAULT_MENU_ANCHOR_ORIGIN,
  DEFAULT_MENU_TRANSFORM_ORIGIN,
} from '../../../contract/contract-page-components/ContractPageHeaderMenu/contract-page-header-menu-consts/contract-page-default-menu';
import { DeleteCustomerMenuItem } from './DeleteCustomerMenuItem';

type CustomersDotMenuProps = {
  customerId: string;
  customerName: string;
  contractsCount: number;
};

export const CustomersDotMenu: React.FC<CustomersDotMenuProps> = ({
  customerId,
  customerName,
  contractsCount,
}) => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();

  return (
    <div
      onClick={(event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      className="flex justify-center"
    >
      <IconButton onClick={handleMenuOpen} disableRipple>
        <span
          className="mx-2 mb-[3px] inline-block h-[3px] w-[3px] rounded-full shadow-[0_7px_0_#5F6978,0_-7px_0_#5F6978]"
          style={{ backgroundColor: '#5F6978' }}
        />
      </IconButton>
      <Menu
        anchorOrigin={DEFAULT_MENU_ANCHOR_ORIGIN}
        transformOrigin={DEFAULT_MENU_TRANSFORM_ORIGIN}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            className: 'max-w-[250px] w-full shadow-xl',
          },

          list: {
            className: 'py-0',
          }
        }}>
        <Paper elevation={8}>
          <DeleteCustomerMenuItem
            customerId={customerId}
            disabled={contractsCount > 0}
            customerName={customerName}
          />
        </Paper>
      </Menu>
    </div>
  );
};
